module.exports = __webpack_public_path__ + "img/dog_12173.4749852e.png";